import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';

import {
  combineLatest,
  Subscription,
  distinctUntilChanged,
  map
} from 'rxjs';

import { WkIdType } from 'app/shared/constants/wkid.constant';

import { PortugalWkidService } from 'app/shared/services/portugal-wkid.service';

@Component({
  selector: 'app-projection-label',
  templateUrl: 'projection-label.component.html',
  styleUrls: ['projection-label.component.scss'],
})
export class ProjectionLabelComponent implements OnDestroy, OnChanges {
  @Input()
  mapView: __esri.MapView;

  private mapViewSubscription: Subscription;

  private wkidLabelDictionary = new Map<WkIdType, string>([
    [WkIdType.WKID3763, 'PT-TM06/ETRS89'],
    [WkIdType.WKID5016, 'PTRA08 UTM Zone 28N'],
    [WkIdType.WKID5014, 'PTRA08 UTM Zone 25N'],
    [WkIdType.WKID5015, 'PTRA08 UTM Zone 26N'],
    [WkIdType.WKID4326, 'WGS 1984'],
  ]);

  mapProjectionLabel: string = this.wkidLabelDictionary.get(WkIdType.WKID4326)

  constructor(private portugalWkidService: PortugalWkidService) { }

  ngOnDestroy(): void {
    this.mapViewSubscription?.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.mapView) {
      this.handleMapView();
    }
  }

  private handleMapView() {
    this.mapViewSubscription?.unsubscribe();
    if (!this.mapView) {
      return;
    }

    this.mapViewSubscription = combineLatest(
      this.portugalWkidService.onWgs84ModeToggle.pipe(distinctUntilChanged()),
      this.portugalWkidService.onWkidChange
    )
      .pipe(
        map(([wgs84Mode, wkid]) => {
          if (wgs84Mode) {
            return WkIdType.WKID4326
          }
          return wkid
        })
      )
      .subscribe((wkid) => {
        this.mapProjectionLabel = this.wkidLabelDictionary.get(wkid);
      });
  }
}
